import React from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import  { thunk }  from 'redux-thunk';

import reducers from "../reducers";

const createStoreWithMiddleware = applyMiddleware(thunk)(createStore);

const store = (process.env.NODE_ENV === "development")
    ? createStoreWithMiddleware(reducers, composeWithDevTools())
    : createStoreWithMiddleware(reducers);

const StoreProvider = ({ onStartup, children }) => {
    React.useEffect(() => {
        if (onStartup) {
            onStartup(store);
        }
    }, [onStartup]);

    return (
        <Provider store={store}>
            {children}
        </Provider>
    );
};

StoreProvider.propTypes = {
    children: PropTypes.node.isRequired,
    onStartup: PropTypes.func
};

export default StoreProvider;
